import { ref } from 'vue'
import { useCustomerStore, usePaymentMethodsStore } from '@/stores/subscription'
import type { PaymentMethod } from '@/types/subscription'

export function usePaymentMethodActions() {
    const customerStore = useCustomerStore()
    const paymentMethodsStore = usePaymentMethodsStore()

    const isUpdating = ref(false)
    const error = ref<string | null>(null)

    const setAsDefault = async (paymentMethod: PaymentMethod) => {
        error.value = null
        const customerId = customerStore.customer?.stripe_customer_id

        if (!customerId) {
            error.value = 'Customer not found'
            throw new Error('Customer not found')
        }

        isUpdating.value = true

        try {
            await paymentMethodsStore.setDefaultPaymentMethod(
                paymentMethod.stripe_payment_method_id,
                customerId
            )
        } catch (err: any) {
            error.value = err?.message ?? 'Failed to set default payment method'
            throw err
        } finally {
            isUpdating.value = false
        }
    }

    const deletePaymentMethod = async (paymentMethodId: number) => {
        error.value = null
        isUpdating.value = true

        try {
            await paymentMethodsStore.deletePaymentMethod(paymentMethodId)
        } catch (err: any) {
            error.value = err?.message ?? 'Failed to delete payment method'
            throw err
        } finally {
            isUpdating.value = false
        }
    }

    return {
        isUpdating,
        error,
        setAsDefault,
        deletePaymentMethod
    }
}
